import { Pipe, PipeTransform } from '@angular/core';

export function formatColumnDisplayName(value: unknown): string {
  if (value === null || value === undefined) return '';
  const raw = String(value).trim();
  if (!raw) return '';

  const formatted = raw
    .replace(/[_\-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, ch => ch.toUpperCase());

  return formatted || raw;
}

@Pipe({
    name: 'columnDisplayName',
    standalone: false
})
export class ColumnDisplayNamePipe implements PipeTransform {
  transform(value: unknown): string {
    return formatColumnDisplayName(value);
  }
}
